import {useContext, useEffect} from "react";
import {observer} from "mobx-react";
import type {BookingWizardSlideComponent} from "./types";
import {useQuery} from "@tanstack/react-query";
import {trpc} from "@/app/trpc";
import {Loader, SelectButton, YStack} from "@chayka/ui";
import {BookingStateContext} from "../state";

export const SubTypeSlide: BookingWizardSlideComponent = observer(({setNextDisabled}) => {
  const {superType, subType, setSubType, queryRoomId} = useContext(BookingStateContext);

  if (!superType) {
    throw new Error("Не выбран тип комнаты"); // TODO: invariant, Sentry
  }

  const {data, isFetching} = useQuery(
    trpc.booking.subTypes.queryOptions({
      superTypeCode: superType.code,
      roomId: queryRoomId || undefined,
    }),
  );

  useEffect(() => {
    const nextSubType =
      data?.find((item) => item.code === subType?.code && !item.disabled) ||
      data?.find((item) => !item.disabled) ||
      null;

    setSubType(nextSubType);
  }, [data, setSubType, subType?.code]);
  useEffect(() => setNextDisabled(!subType), [subType, setNextDisabled]);

  if (isFetching) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <Loader />
      </div>
    );
  }

  return (
    <YStack className="w-full gap-3">
      {data?.map((st) => (
        <SelectButton
          key={st.code}
          className="w-full"
          selected={st.code === subType?.code}
          disabled={st.disabled}
          onClick={() => setSubType(st)}
        >
          {st.name}
        </SelectButton>
      ))}
    </YStack>
  );
});
